import { UserLayout } from "layouts";
import { lazy, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Loadable, Page } from 'components';
import { setRouting } from 'toolkits/redux/routing';
import { Navigate, useRoutes } from 'react-router-dom';

const NotFound = Loadable(lazy(() => import("components/NotFound")));
const Dashboard = Loadable(lazy(() => import('screens/UserRole/Dashboard')));
const Callback = Loadable(lazy(() => import("screens/Authentication/Callback")));

const navConfig = [
  {
    path: "/",
    element: <Navigate to="/intro" replace />,
  },
  {
    url: "/",
    path: "/",
    title: "intro",
    inSidebar: true,
    element: <UserLayout />,
    children: [
      {
        url: "/intro",
        path: "/intro",
        title: "intro",
        inSidebar: true,
        element: <Dashboard />,
      },
      {
        url: "/callback",
        path: "/callback",
        title: "callback",
        inSidebar: false,
        element: <Callback />,
      },
    ],
  },
  {
    path: "/",
    element: <UserLayout />,
    children: [
      {
        path: "404",
        element: <NotFound />,
      },
      {
        path: "sign-in",
        element: <Navigate to="/" replace />,
      },
      {
        path: "sign-up",
        element: <Navigate to="/" replace />,
      },
      {
        path: "reset-password",
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

function cleanRoutes({ url, title, inSidebar, children }) {
  if (inSidebar) {
    if (children && children.length > 0) {
      children = children.map((c) => cleanRoutes(c));
      return { url, title, inSidebar, children };
    }
    return { url, title, inSidebar, children: [] };
  }
  return {};
}

export default function Router() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setRouting(navConfig.map((x) => cleanRoutes(x)).filter((x) => x)));
  }, []);
  return useRoutes(navConfig);
}
